<template>
  <div v-if="reportData">
    <v-row class="px-5 py-4">
      <!-- Star values - 3 cols -->
      <v-col class="text-center">
        <span v-if="this.loading == true">
          <v-progress-circular width="2" indeterminate color="secondary"></v-progress-circular>
        </span>
        <span v-else>
          <v-chip class="px-5 text-h5" large outlined color="primary">
            <span>3.26</span><v-icon>mdi-star-outline</v-icon>
          </v-chip>
        </span>
        <div class="pt-2 text-h6">Overall Rating</div>
      </v-col>
      <v-col class="text-center">
        <span v-if="this.loading == true">
          <v-progress-circular width="2" indeterminate color="secondary"></v-progress-circular>
        </span>
        <span v-else>
          <v-chip class="px-5 text-h5" large outlined color="primary">
            <span>3.07</span><v-icon>mdi-star-outline</v-icon>
          </v-chip>
        </span>
        <div class="pt-2 text-h6">HEDIS</div>
      </v-col>
      <v-col class="text-center">
        <span v-if="this.loading == true">
          <v-progress-circular width="2" indeterminate color="secondary"></v-progress-circular>
        </span>
        <span v-else>
          <v-chip class="px-5 text-h5" large outlined color="primary">
            <span>3.50</span><v-icon>mdi-star-outline</v-icon>
          </v-chip>
        </span>
        <div class="pt-2 text-h6">Patient Safety</div>
      </v-col>
    </v-row>
    <v-row class="px-5">
      <!-- Charts - 5 cols -->
      <v-col cols="12" lg="6">
        <v-skeleton-loader :loading="loading" transition="scale-transition" type="table-tbody">
          <v-card outlined class="pa-3" width="100%">
            <horizontal-bar-chart :data="barData" :options="barOptions"></horizontal-bar-chart>
          </v-card>
        </v-skeleton-loader>
      </v-col>
      <v-col cols="12" lg="3">
        <v-skeleton-loader :loading="loading" transition="scale-transition" type="card">
          <v-card outlined class="pa-3">
            <v-card-title class="justify-center">Opportunities</v-card-title>
            <pie-chart :data="opportunityData" :options="opportunityOptions"></pie-chart>
          </v-card>
        </v-skeleton-loader>
      </v-col>
      <v-col cols="12" lg="3">
        <v-skeleton-loader :loading="loading" transition="scale-transition" type="card">
          <v-card outlined class="pa-3">
            <v-card-title class="justify-center">Patient Summary</v-card-title>
            <pie-chart :data="patientData" :options="patientOptions"></pie-chart>
          </v-card>
        </v-skeleton-loader>
      </v-col>
    </v-row>
    <v-row class="px-5">
      <v-col cols="12">
        <!-- data table -->
        <v-card outlined>
          <v-data-table
            :headers="headers"
            :items="reportData"
            loading-text="Loading data..."
            class="elevation-0 col-md-12 m-auto"
          ></v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </div>
  <v-row v-else>
    <v-col class="pt-0 pb-0">
      <v-alert class="mb-0" type="info" :value="true">
        Please select an insurance to continue
      </v-alert>
    </v-col>
  </v-row>
</template>
<script>
import pieChart from "../charts/piechart";
import HorizontalBarChart from "../charts/HorizontalBarChart";

export default {
  name: "QualityScorecard",
  props: ["reportData"],
  components: {
    pieChart,
    HorizontalBarChart
  },
  data() {
    return {
      loading: false,
      headers: [
        { text: "Measure Name", value: "MeasureName" },
        { text: "Pass Percentage", value: "PassPercentage" },
        { text: "Passing", value: "Passing" },
        { text: "Eligible", value: "Eligible" },
        { text: "Open", value: "Open" },
        { text: "Opp 4 Star", value: "Opp4Star" },
        { text: "Opp 5 Star", value: "Opp5Star" },
        { text: "Star Level", value: "StarLevel" },
        { text: "Star 1 Threshold", value: "Star1Threshold" },
        { text: "Star 2 Threshold", value: "Star2Threshold" },
        { text: "Star 3 Threshold", value: "Star3Threshold" },
        { text: "Star 4 Threshold", value: "Star4Threshold" },
        { text: "Star 5 Threshold", value: "Star5Threshold" }
      ],
      barData: {
        datasets: [
          {
            data: [77, 86, 79],
            backgroundColor: ["#a00037", "#7b1fa2", "#303f9f"],
            barPercentage: 0.75
          }
        ],
        // These labels appear in the legend and in the tooltips when hovering different arcs
        labels: ["Aggregate Pass %", "Medication Adherence", "Patient Experience"]
      },
      barOptions: {
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              stacked: true
            }
          ],
          yAxes: [
            {
              stacked: true
            }
          ]
        },
        legend: {
          display: false
        }
      },
      opportunityData: {
        datasets: [
          {
            data: [1542, 355],
            backgroundColor: ["#6abf69", "#00600f"]
          }
        ],
        // These labels appear in the legend and in the tooltips when hovering different arcs
        labels: ["Eligible Opportunities", "Open Opportunities"]
      },
      opportunityOptions: {
        elements: {
          arc: {
            borderWidth: 0
          }
        },
        legend: {
          align: "start",
          position: "bottom"
        }
      },
      patientData: {
        datasets: [
          {
            data: [10, 20],
            backgroundColor: ["#ff7d47", "#ac0800"]
          }
        ],
        // These labels appear in the legend and in the tooltips when hovering different arcs
        labels: ["Patients", "Patients w/ Open Opportunities"]
      },
      patientOptions: {
        elements: {
          arc: {
            borderWidth: 0
          }
        },
        legend: {
          align: "start",
          position: "bottom"
        }
      }
    };
  }
};
</script>
<style scoped></style>
